import React, { lazy, Suspense } from 'react'
import {Route, Routes, Navigate, useLocation} from 'react-router-dom'
import Home from 'views/home' // 메인페이지
import Join from 'views/join'
import Member from 'views/member'
// import Recommend from 'views/recommend'
import Alert from 'views/alert'
import Data from 'views/data'
// import Mydata from 'views/mydata'
import Life from 'views/life'
import Setting from 'views/setting'
import Fincar from 'views/fincar'
import ThinkPool from 'views/thinkpool'
import NotFound from 'views/NotFound'
import { Auth } from 'components'
import ResetPassword from 'views/join/form'
import VerifyPassword from 'views/join/verify'
import ChangePassword from 'views/setting/cert/ChangePasswordPage'
import DataCertificate from 'views/dataCertificate'
import Certificate from 'views/dataCertificate/Certificate'
import { Loading } from 'components'
import MoneeyLanding from "./views/landing/MoneeyLanding";
import Main from 'views/main/home'

const Mydata = lazy(() => import('views/mydata'))
const Recommend = lazy(() => import('views/recommend'))
const EdocCertificate = lazy(() => import('views/edoc'))

const Router = ({ didRun }) => {
	if (didRun === false) {
		return (
			<Routes>
				<Route path="*" element={<Join />} />
			</Routes>
		)
	} else {
		// console.log(../../public/real_estate/index.html);
		return (
			<Routes>
				<Route path="/moneey-landing/*" element={<MoneeyLanding />} /> 	{/* 렌딩 페이지 추가 */}
				<Route path="/member/*" element={<Member />} />
				<Route path="/recommend/*" element={<Auth><Suspense fallback={<Loading />}><Recommend /></Suspense></Auth>} />
				<Route path="/alert/*" element={<Alert />} />
				<Route path="/setting/*" element={<Setting />} />
				<Route path="/data/*" element={<Auth><Suspense fallback={<Loading />}><Data /></Suspense></Auth>} />
				<Route path="/mydata/*" element={<Auth><Suspense fallback={<Loading />}><Mydata /></Suspense></Auth>} />
				<Route path="/life/*" element={<Life />} />
				<Route path="/fincar/*" element={<Fincar />} />
				<Route path="/thinkpool/*" element={<Auth><ThinkPool /></Auth>} />
				<Route path="/home/*" element={<Auth><Home /></Auth>} />
				<Route path="/resetPassword" element={<ResetPassword />} /> { /* 비번 리셋 */}
				<Route path="/verifyPassword" element={<VerifyPassword />} /> { /* 비번 검증 */}
				<Route path="/changePassword" element={<ChangePassword />} /> { /* 비번 변경 */}
				<Route path="/dataCertificate" element={<DataCertificate />} /> {/* 데이터 증명서 비번입력 */}
				<Route path="/certificate" element={<Certificate />} /> {/* 데이터 증명서 */}

				<Route path="/edocCertificate/*" element={<Auth><Suspense fallback={<Loading />}><EdocCertificate /></Suspense></Auth>} />  {/* 전자증명서 */}
				<Route path="/" element={<Navigate to="/home" />} />
				{/* <Route path="/main" element={<Auth><Main/></Auth>} /> */}

				<Route path="/realEstate" element={<RealEstate />} />
				{/* <Route path="/realEstate" element={() => {return {__html: "<iframe src='/real_estate/index.html'></iframe>"}}}/> */}
				<Route path="/test" element={<a style={{padding: "10rem"}} href={process.env.PUBLIC_URL+"/real_estate/index.html"}>부동산등기부등본</a>} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		)
	}
}

const RealEstate = () => {
	const pageChange = () => {
		console.log("click");
		window.location.href="/real_estate/index.html"
	}

	return (
		<div onClick={pageChange} style={{padding: "10rem"}} >부동산등기부등본</div>
	);
}

export default Router
